// src/pages/fleet/useIsMobile.js — tiny viewport hook for responsive layouts.
import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 820) {
  const [mobile, setMobile] = useState(typeof window !== 'undefined' && window.innerWidth < breakpoint);
  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return mobile;
}
